import { GET_CUSTOMER_PRICE_LIST_REGISTER } from "../../../../constants/ActionTypes";
import { zeroPad } from "../../../../util/DaFrameword";


const InitialValue={
    CustomerPriceList:[]
}

function CustomerPriceRegister(state=InitialValue,action){

    switch (action.type) {
        case GET_CUSTOMER_PRICE_LIST_REGISTER:
            return {
                ...state,
                    CustomerPriceList:action.payload.map(x=>({
                    id:x.id,
                    description:x.description,
                    // customerPriceKind:x.customerPriceKind.description,
                    // customerPriceKindId: x.customerPriceKind.id,
                    aboveOrBelowPercentId:x.aboveOrBelowPercent,
                    aboveOrBelowPercent:x.aboveOrBelowPercent===1?"Arriba del precio":x.aboveOrBelowPercent===2? "Debajo del precio": "",
                    percent: x.percent
                })) 
            }
        default:
           return state
    }  

}

export default CustomerPriceRegister;